module.exports = __webpack_public_path__ + "static/media/side_banner_01.c47b48b4.jpg";